import * as THREE from 'three';
import React, { useEffect, useRef } from 'react';
import { ILight } from '../lightTemplate';
import { Line, Point, useHelper } from '@react-three/drei';

type IDirectionalLightProps = {
  instanceId: string;
  castShadow?: boolean;
  light?: ILight | undefined;
};

export const DirectionalLight = (props: IDirectionalLightProps) => {
  const lightRef = props.light?.ref;

  const targetRef = useRef<THREE.Object3D>(new THREE.Object3D());

  useEffect(() => {
    lightRef.current.castShadow = props.castShadow;

    lightRef.current.shadow.mapSize.width = props.light?.shadowMapWidth || 512;
    lightRef.current.shadow.mapSize.height =
      props.light?.shadowMapHeight || 512;

    lightRef.current.shadow.camera.near = props.light?.shadowCameraNear || 1;
    lightRef.current.shadow.camera.far = props.light?.shadowCameraFar || 500;

    lightRef.current.shadow.bias = props.light?.shadowBias || -0.002;

    lightRef.current.shadow.needsUpdate = true;
  }, []);

  useHelper(lightRef, THREE.DirectionalLightHelper, 1, 'white');

  return (
    <>
      <primitive object={targetRef.current} position={[0, 0.5, 10]} />
      <directionalLight
        ref={lightRef}
        color={props.light?.color !== undefined ? props.light.color : 0xffffff}
        intensity={
          props.light?.intensity !== undefined ? props.light.intensity : 1
        }
        position={[0, 0.5, 0]}
        castShadow={props.castShadow !== undefined ? props.castShadow : false}
        target={targetRef.current}
        key={`light-${props.instanceId}`}
      />
    </>
  );
};
